module.exports = __webpack_public_path__ + "static/determined-collapsed-3-12b0f6301af2463f0873cc2059625803.png";